export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6594.edfab4ef.jpg";